<template>
  <v-card max-width="400" style="border-radius: 0px;" class="transaction-details">

    <!-- Card Header -->
    <v-card-title class="header">
      <!-- Left Side -->
      <div style="display: flex; flex-direction: column;">
        <span class="font-weight-black title white--text">{{record.currency}}</span>
        <div style="display: flex; align-items: baseline;">
          <span style="color: #BCC1D1; font-size: 14px;">{{recordDate(record.inserted_at)}}</span>
          <span style="color: #BCC1D1; font-size: 12px; margin-left: 8px">{{recordTime(record.inserted_at)}}</span>
        </div>
      </div>
      <!-- Right Side -->
      <div class="ml-4">
        <v-tooltip top :color="textColorForChip(record)">
          <template v-slot:activator="{ on }">
            <v-chip class="fixed-chip" :color="statusColorFor(record)" :text-color="textColorForChip(record)" v-on="on">{{ statusTextFor(record) }}</v-chip>
          </template>
          <span class="font-weight-bold">{{ statusHelpFor(record) }}</span>
        </v-tooltip>
      </div>
      <v-spacer></v-spacer>
      <v-icon style="cursor: pointer" right dark @click="$emit('closeDialog')">close</v-icon>
    </v-card-title>

    <!-- Card Body -->
    <v-card-text style="color: #44517B;">
      <v-container grid-list-md pt-0 pb-0>
        <v-layout wrap>
          <v-flex xs12>

            <!-- Details -->

            <div>
              <v-chip color="rgba(39, 218, 188, 0.2)" text-color="#27DABC" class="chip-title">
                {{i18n('Detalhes').toUpperCase()}}
              </v-chip>
            </div>
            <div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Value')}}:</span><span class="font-size-14"> {{this.record.value}} </span><span class="font-size-10">({{this.record.currency}})</span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Taxa')}}:</span><span class="font-size-14"> {{this.record.tax_value}} </span><span class="font-size-10">({{this.record.currency}})</span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Wire ID')}}:</span><span class="font-size-14"> {{this.record.id}} </span></div>
            </div>

            <div>
              <v-chip color="rgba(39, 218, 188, 0.2)" text-color="#27DABC" class="chip-title">
                {{i18n('De').toUpperCase()}}
              </v-chip>
            </div>
            <div>
              <div class="mb-1"><span class="font-size-10">{{i18n('OrigemB')}}:</span><span class="font-size-14"> {{this.record.from_bank_account.owner_name}} </span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Banco')}}:</span><span class="font-size-14"> {{this.record.from_bank_account.bank.name}} </span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Swift')}}:</span><span class="font-size-14"> {{this.record.from_bank_account.bank.swift}} </span></div>
              <div class="mb-1" v-if='this.record.from_bank_account.branch_number'><span class="font-size-10">{{i18n('Agência')}}:</span><span class="font-size-14"> {{this.record.from_bank_account.branch_number}} </span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Número da conta')}}:</span><span class="font-size-14"> {{this.record.from_bank_account.account_number}} </span></div>
            </div>

            <div>
              <v-chip color="rgba(39, 218, 188, 0.2)" text-color="#27DABC" class="chip-title">
                {{i18n('Para').toUpperCase()}}
              </v-chip>
            </div>
            <div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Cliente')}}:</span><span class="font-size-14"> {{this.record.to_bank_account.company.social_name}} </span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Banco')}}:</span><span class="font-size-14"> {{this.record.to_bank_account.bank.name}} </span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Swift')}}:</span><span class="font-size-14"> {{this.record.to_bank_account.bank.swift}} </span></div>
              <div class="mb-1" v-if='this.record.to_bank_account.branch_number'><span class="font-size-10">{{i18n('Agência')}}:</span><span class="font-size-14"> {{this.record.to_bank_account.branch_number}} </span></div>
              <div class="mb-1"><span class="font-size-10">{{i18n('Número da conta')}}:</span><span class="font-size-14"> {{this.record.to_bank_account.account_number}} </span></div>
            </div>

          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn flat style="color: #44517B; flex: 1" @click="$emit('closeDialog')">{{i18n('Fechar')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import utils from "./shared/Utils"
export default {
  name: 'CustomerScheduledBankTransactionDetailsCard',
  props: {
    record: {
      type: Object
    }
  },
  data: (vm) => {
    return {
      exchange_rate: 1.0,
      company: false
    }
  },
  computed: {},
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    recordDate(date) {
      return utils.dbDateTimeToHuman(date).split(' ')[0]
    },
    recordTime(time) {
      return utils.dbDateTimeToHuman(time).split(' ')[1]
    },
    statusTextFor(record) {
      const status_map = {
        canceled: this.i18n('Transação Cancelada'),
        pending: this.i18n('Transação Pendente'),
        identified: this.i18n('Transação Identificada'),
        exchanged: this.i18n('Transação Convertida'),
        wired: this.i18n('Transação Transferida')
      }
      return status_map[record.status]
    },
    statusHelpFor(record) {
      const status_help_map = {
        canceled: this.i18n('Transação cancelada'),
        pending: this.i18n('Aguardando pela identificação do transferência de entrada'),
        identified: this.i18n('Transferência de entrada identificada'),
        exchanged: this.i18n('Taxa de câmbio fechada'),
        wired: this.i18n('O valor convertido foi enviado')
      }
      return status_help_map[record.status]
    },
    statusColorFor(record) {
      const status_color_map = {
        canceled: 'rgba(200, 200, 200, 0.8)',
        pending: 'rgba(144, 140, 99, 0.3)',
        identified: 'rgba(103, 145, 220, 0.3)',
        exchanged: 'rgba(68, 188, 202, 0.4)',
        wired: 'rgba(7, 169, 124, 0.3)'
      }
      return status_color_map[record.status]
    },
    textColorForChip(record) {
      const status_chip_color_map = {
        canceled: '#4e4e4e',
        pending: '#908c63',
        identified: '#a4b6d6',
        exchanged: '#40c1d0de',
        wired: '#07a97c'
      }
      return status_chip_color_map[record.status]
    }
  },
  mounted() {
    this.$root.store.getCompany((company)=>{
      if (company) {
        this.company = company
      }
    }, (error)=>{
    })
  }
}
</script>
<style>
.transaction-details .header {
  background-color: #0C2E4A !important;
  border-radius: 0px !important;
}

.transaction-details .font-size-10 {
  font-size: 10px;
}
.transaction-details .font-size-14 {
  font-size: 14px;
}

.transaction-details .chip-title {
  margin: 0;
  font-size: 10px;
  border-radius: 0px;
  height: 14px;
}
.transaction-details .chip-title .v-chip__content {
  padding-left: 7px;
  padding-right: 7px;
}
</style>



// WEBPACK FOOTER //
// src/CustomerInternalWireDetailsCard.vue